import { Component } from "@angular/core";
import { Debounce } from "lodash-decorators";
import * as _ from 'lodash';
import { ToastrService } from "ngx-toastr";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { CareersService } from "./services/careers.service";
import { Career } from "./models/career";
import { ConfirmRemovalComponent } from './confirm-removal.component';

@Component({
  selector: 'career-list',
  templateUrl: './careers-list.component.html',
  styleUrls : ['./careers-list.component.css'],
  providers: [CareersService]
})
export class CareersListComponent {

  careers: Array<Career> = [];
  loaded: boolean = false;
  confirmRemovalModal: BsModalRef;

  constructor(private careersService: CareersService, private toastr: ToastrService,
    private modalService: BsModalService) { }

  ngOnInit() {

    this.loadCareers();
  }

  loadCareers() {
    this.careersService.get().subscribe(res => {
      this.loaded = true;
      console.log('Careers', res);
      this.careers = res;
    }, error => {
        console.log('Career Error', error);
    });
  }

  @Debounce(500)
  listChange(e: any) {
    this.careers.forEach(c => {
      //update index on obj
      c.index = _.indexOf(this.careers, c);

      this.careersService.update(c).subscribe(res => {
      },
        error => {
          console.log("Error updating", error, c);
          this.toastr.error("Error updating job");
        });
    });
  }

  moveUp(career: Career) {
    var i = 0;
    i = _.indexOf(this.careers, career);

    if (i !== 0) {

      this.careers.splice(i--, 0, this.careers.splice(i, 1)[0]);

      this.careers = [...this.careers];
    }

    this.listChange('');
  }
  moveDown(career: Career) {
    var i = 0;
    i = _.indexOf(this.careers, career);
    var max = this.careers.length - 1;

    if (i !== max) {
      this.careers.splice(i++, 0, this.careers.splice(i, 1)[0]);

      this.careers = [...this.careers];
    }

    this.listChange('');
  }
  remove(career: Career) {
    const initialState = {
      career: career
    };

    //Confirm Modal
    this.confirmRemovalModal = this.modalService.show(ConfirmRemovalComponent, { initialState });

    this.confirmRemovalModal.content.onClose.subscribe(res => {


      console.log('onClose', res);
      if (res) {
        //Remove from list

        this.careersService.remove(career.id).subscribe(res => {

          this.careers = this.careers.filter(f => f.id != career.id);
          this.careers = [...this.careers];

          //Update list
          this.listChange('');
        }, error => {
            console.log("Error Deleting", error, career);
            this.toastr.error("Error removing career");
        });
      }
    });


  }
}
